module.exports = __webpack_public_path__ + "static/media/preview_earning_campaigns_2.69e48901.svg";